const calculators: { url: string; title: string; date: string; image: string }[] = [
  {
    url: '/r-calcs-v2/2021-01-24b',
    title: 'R-Value Calculator',
    date: '24 Jan 2021',
    image: '/thumb-rcalculator.png',
  },
  {
    url: '/r-calcs-v1/2020-11-14-lockdown59',
    title: 'R-Value Calculator (restrictive)',
    date: '14 Nov 2020',
    image: '/thumb-rcalculator.png',
  },
  {
    url: '/r-calcs-v1/2020-11-14-lockdown84',
    title: 'R-Value Calculator (permissive)',
    date: '14 Nov 2020',
    image: '/thumb-rcalculator.png',
  },
  {
    url: '/r-calcs-v1/2020-10-23',
    title: 'R-Value Calculator',
    date: '23 Oct 2020',
    image: '/thumb-rcalculator.png',
  },
  {
    url: '/risk-calcs/2020-11-11',
    title: 'Activity Risk Calculator',
    date: '11 Nov 2020',
    image: '/thumb-risk-calculator.png',
  },
]

export default calculators
